import type { ComponentPropsWithoutRef, FC } from "react";

type CmsHtmlProps = Omit<
  ComponentPropsWithoutRef<"div">,
  "children" | "dangerouslySetInnerHTML"
> & {
  children?: string | null;
};

export const CmsHtml: FC<CmsHtmlProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <div
      {...props}
      className={className}
      dangerouslySetInnerHTML={{ __html: children ?? "" }}
    />
  );
};
